import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'attendance/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('attendance/', '')
      .toLowerCase();
  }
}
